import React from "react";

import { TabContainer } from "./container";
import { GameParams } from "../../../validation/game-params";

type TabType = (props: {
    id?: string;
    namespace: string;
    children: (props: {
        locale: LocaleSettings;
        data: GameData;
        userSettings: GameParams;
    }) => JSX.Element;
}) => JSX.Element;

export const Tab: TabType = TabContainer;

(Tab as React.FC)["displayName"] = "Tab";
